import { getAll } from '@/api/gabed/materiel';
import store from '@/store/store';
import { NO_PAGINATION } from '@/configuration/clientTableConf';

export default async function getMateriels(materiels) {
  const materielsFiltered = [...new Set(materiels)];
  if (materielsFiltered.length === 0) return [];

  const materielsApi = (await getAll({
    query: {
      societeId: store.getters['societe/societeActiveId'],
      agencesId: store.getters['societe/agenceActive'].map((agence) => agence.agenceId),
      codes: materielsFiltered,
      actif: true,
    },
    limit: NO_PAGINATION,
  })).data.result.items;

  const errors = [];
  materielsFiltered.forEach((materiel) => {
    const isInResult = materielsApi.find((m) => {
      return m.code === materiel.toString();
    });
    if (!isInResult) {
      errors.push({
        message: 'importDonne.dataNotExist',
        parametres: { data: materiel },
      });
    }
  });
  if (errors.length > 0) throw errors;

  return materielsApi;
}
